// © 2015-2021 WDNA - All Rights Reserved

/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/control-has-associated-label */

import _ from 'lodash';
import * as React from 'react';

import Select2, { DataSelect2, EventSelect2 } from 'wdna-select2';
import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

import { LovDO } from '../../../../types';
import { ClientDO, CompanyDO } from '../../requests';

interface Props {
  formValues: {
    id: number;
    data: Partial<ClientDO>;
    isFile: boolean;
    modalShow: boolean;
    companiesArray: Partial<CompanyDO>[];
    accessListArray: LovDO[];
  };
  fileId: string;
  fileName: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onChangeFile: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeMultiple: (e: EventSelect2) => void;
  download: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCloseModal: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleUploadFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onHandleDeletedFile: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showFreeboard: (e: React.MouseEvent<HTMLButtonElement>) => void;
  genApiKey: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

/**
 * Function to create a React Component component
 *
 * @param props component properties
 * @returns react node component
 */
function Form(props: Props): JSX.Element {
  const { formValues, fileName, fileId } = props;
  const { id, data, modalShow, isFile } = formValues;
  const { companiesArray, accessListArray } = formValues;

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Email</b> &nbsp; &nbsp;&nbsp;
          </label>
          <input
            type="email"
            id="data.email"
            name="data.email"
            value={_.defaultTo(data.email, '')}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Email"
            required
            readOnly
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Company</b> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
          </label>
          <Select2
            id="data.companyId"
            name="data.companyId"
            value={_.defaultTo(data.companyId, '')}
            onChange={props.onChange}
            data-ctype="number"
            data={companiesArray.map((item: Partial<CompanyDO>): DataSelect2 => {
              return { id: item.id!, text: item.name! };
            })}
            options={{ placeholder: '(empty)' }}
            style={{ width: '80%' }}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Dashboard</b> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
          </label>
          <Select2
            id="accessListArray"
            name="accessListArray"
            value={data.accessList}
            onSelect={props.onChangeMultiple}
            onUnselect={props.onChangeMultiple}
            data={accessListArray.map((item: LovDO): DataSelect2 => {
              return { text: item.name, id: item.id };
            })}
            options={{ placeholder: 'Select option' }}
            style={{ width: '80%' }}
            multiple
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Main Dashboard</b> &nbsp;
          </label>
          <input
            type="text"
            id="dashboardOrder"
            name="dashboardOrder"
            value={_.defaultTo(data?.accessList?.[0], '')}
            onChange={props.onChange}
            className="input-new"
            style={{ width: '80%' }}
            placeholder="Main Dashboard"
            readOnly
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-4">
          <label className="label">
            <b>API Key</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.apikey"
            name="data.apikey"
            value={_.defaultTo(data.apikey, '')}
            className="input-new"
            style={{ width: '80%' }}
            placeholder="API Key"
            readOnly
          />
        </div>
        <div className="col-2">
          <label className="label">&nbsp;</label>
          <button
            type="button"
            onClick={props.genApiKey}
            className="btn btn-secondary"
            style={{ margin: '0px 0 0 5px', padding: '0 22px', height: '31px' }}
          >
            Generate
          </button>
        </div>
        <div className="col-6">
          <label className="label">
            <b>Status</b> &nbsp;
          </label>
          <input
            type="checkbox"
            id="data.active"
            name="data.active"
            checked={data.active || false}
            onChange={props.onChange}
            className="input-new"
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Active
          </label>
        </div>
      </div>
      <ContainerModal
        fullScreenButton={false}
        show={modalShow}
        title="SELECT DASHBOARD"
        modalClass="selector-modal"
        onClose={props.onCloseModal}
        footerButtons={[
          {
            text: 'OK',
            className: 'btn btn-primary',
            onClick: props.onCloseModal,
          },
        ]}
      >
        <div>
          <label className="label">
            <b>Selected File</b>
          </label>
          <div className="input input-file">
            <span className="button">
              <input
                id={fileId}
                name="file"
                type="file"
                onChange={props.onChangeFile}
                style={{ width: '75%' }}
                required={!id}
                accept=".json"
              />
              <br />
              <label className="label">
                <b>Browse</b>
              </label>
              <br />
            </span>
            <div className="cl-element btn-select2-addon">
              <input type="text" id={fileName} placeholder="Include some files" readOnly style={{ width: '55%' }} />
              &nbsp;&nbsp;
              <button
                type="button"
                onClick={props.onHandleUploadFile}
                className="btn btn-default"
                style={{ right: 'unset' }}
              >
                Save
              </button>
              <div hidden={!isFile}>
                <button
                  type="button"
                  onClick={props.onHandleDeletedFile}
                  className="btn btn-default"
                  style={{ right: '40px', top: '0px' }}
                >
                  Delete
                </button>
              </div>
            </div>
            <br />
            <label className="label">
              <b>Old File</b>
            </label>
            <div hidden={isFile}>
              <input
                type="text"
                value="No files in server"
                className="input-new"
                style={{ width: '55%' }}
                readOnly
                size={50}
              />
            </div>
            <div hidden={!isFile} className="cl-element btn-select2-addon">
              <input
                type="text"
                value={`client_${data.id}.json`}
                className="input-new"
                style={{ width: '55%' }}
                readOnly
                size={50}
              />
              &nbsp;&nbsp;
              <button
                type="button"
                onClick={props.download}
                className="btn btn-default"
                style={{ right: 'unset' }}
              >
                Download
              </button>
              <button
                type="button"
                onClick={props.showFreeboard}
                className="btn btn-default"
                style={{ right: '40px' }}
              >
                Show
              </button>
            </div>
          </div>
        </div>
      </ContainerModal>
    </fieldset>
  );
}

export default Form;
